// import './App.css';
import React, { useState } from 'react';
import FooterPrime from '../container/Footer/Footer';

import Ideas from '../components/ideas/Ideas';
import Filtro from '../components/filtro/Filtro';
import ListBlog from '../components/listBlog/ListBlog';
import IdeasForm from '../components/ideasForm/IdeasForm';
import Navbar from '../container/navbar/Navbar';

function SecIdeas() {

  const [activeTab, setActiveTab] = useState(1); // Estado para rastrear la pestaña activa

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber); // Actualizar la pestaña activa al hacer clic en ella
  };

  const [count, setCount] = React.useState(0);


  return (
    <div className="SecIdeas">
      <Navbar></Navbar>
      <Ideas></Ideas>
      <ListBlog></ListBlog>
      <IdeasForm/>
      <FooterPrime></FooterPrime>
    </div>
  );
}

export default SecIdeas;
